import type { DiagnosticReport } from '@ts-assessment/interfaces'

import { DiagnosticReportType } from '@ts-assessment/enums'

const configDiagnosticReportStrengths: DiagnosticReport = {
  id: DiagnosticReportType.Strengths,
  title: 'Strengths',
}

const configDiagnosticReportImprovements: DiagnosticReport = {
  id: DiagnosticReportType.Improvements,
  title: 'Areas of improvement',
}

export const configDiagnosticReports: DiagnosticReport[] = [
  configDiagnosticReportStrengths,
  configDiagnosticReportImprovements,
]
